import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-account-admin-picker',
  templateUrl: './account-admin-picker.component.html',
  styleUrls: ['./account-admin-picker.component.scss'],
})
export class AccountAdminPickerComponent {
  @Input() adminAccounts: Array<{ id: number; name: string }> = [];
  public selectedAccountId: number;

  constructor(private modalController: ModalController) {}

  dismiss() {
    this.modalController.dismiss();
  }

  confirm() {
    if (this.selectedAccountId == null) {
      return;
    }
    this.modalController.dismiss({ accountId: this.selectedAccountId });
  }
}
